/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AntiBandingMode {
}

export enum AntiBandingMode_Enum {
  ANTI_BANDING_OFF = 0,
  ANTI_BANDING_AUTO = 1,
  ANTI_BANDING_50HZ = 50,
  ANTI_BANDING_60HZ = 60,
  UNRECOGNIZED = -1,
}

export function antiBandingMode_EnumFromJSON(object: any): AntiBandingMode_Enum {
  switch (object) {
    case 0:
    case "ANTI_BANDING_OFF":
      return AntiBandingMode_Enum.ANTI_BANDING_OFF;
    case 1:
    case "ANTI_BANDING_AUTO":
      return AntiBandingMode_Enum.ANTI_BANDING_AUTO;
    case 50:
    case "ANTI_BANDING_50HZ":
      return AntiBandingMode_Enum.ANTI_BANDING_50HZ;
    case 60:
    case "ANTI_BANDING_60HZ":
      return AntiBandingMode_Enum.ANTI_BANDING_60HZ;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AntiBandingMode_Enum.UNRECOGNIZED;
  }
}

export function antiBandingMode_EnumToJSON(object: AntiBandingMode_Enum): string {
  switch (object) {
    case AntiBandingMode_Enum.ANTI_BANDING_OFF:
      return "ANTI_BANDING_OFF";
    case AntiBandingMode_Enum.ANTI_BANDING_AUTO:
      return "ANTI_BANDING_AUTO";
    case AntiBandingMode_Enum.ANTI_BANDING_50HZ:
      return "ANTI_BANDING_50HZ";
    case AntiBandingMode_Enum.ANTI_BANDING_60HZ:
      return "ANTI_BANDING_60HZ";
    case AntiBandingMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAntiBandingMode(): AntiBandingMode {
  return {};
}

export const AntiBandingMode = {
  encode(_: AntiBandingMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AntiBandingMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAntiBandingMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AntiBandingMode {
    return {};
  },

  toJSON(_: AntiBandingMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AntiBandingMode>, I>>(base?: I): AntiBandingMode {
    return AntiBandingMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AntiBandingMode>, I>>(_: I): AntiBandingMode {
    const message = createBaseAntiBandingMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
